const getDataState = (disabled, isChecked) => {
    if (disabled)
        return "disabled";
    return isChecked ? "checked" : "unchecked";
};

export { getDataState };
